import { createLogger, loggerStyles } from '@ricoh/ria.client.core/plugins/app/logger';

const globalThisJquery = globalThis as GlobalThisJquery;

const logger = createLogger('jquery');

/** Inject JQuery. */
export async function init() {
  logger.write('info', `${loggerStyles.requestText('Load')} jquery`);

  const { default: jquery } = await import('jquery');

  globalThisJquery.jQuery = jquery;
  globalThisJquery.$ = jquery;

  logger.writeWithData('info', `${loggerStyles.responseText('Init')} jquery`, `v${globalThisJquery.$().jquery}`);
}
